import {
    Box,
    ButtonSecondary,
    EmptyState,
    HighlightedCard,
    HorizontalScroll,
    IconShoppingCartRegular,
    RadioButton,
    RadioGroup,
    Text2,
    Text6,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ETypeUser } from '../../utils/store/model/store.model';
import { isBrowser } from 'react-device-detect';
import navigateParams from '../../utils/navigation/navigateParams';
import './index.scss';
import Stopper from '../../components/Stopper/index';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../utils/dataTransformation/tracking';
import { getEnv, managementEnvironment } from '../../utils/dataTransformation/environments';
interface ICardExplore {
    type: any;
    image: string;
    text: string;
    title: string;
    url: string;
    enabled: boolean;
    descriptionText?: string;
    idTrackingCard?: string;
}

interface IChipsExplore {
    text: string;
    enabled: boolean;
    idTrackingFilter?: string;
}

const Explore: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const { trackingUserInteraction } = new TrackingEvents();
    const o2TelevisionEnabled = !!managementEnvironment().VITE_WEBVIEW_O2TELEVISION_EXPLORE_ENABLED;
    const devicesEnabled = !!managementEnvironment().VITE_WEBVIEW_DEVICES_ENABLED;
    const o2cloudExploreEnabled = !!managementEnvironment().VITE_WEBVIEW_O2CLOUD_EXPLORE_ENABLED;
    const postSalesEnabled = !!managementEnvironment().VITE_WEBVIEW_POSTSALES_ENABLED;
    const cardsPreclient = !!managementEnvironment().VITE_WEBVIEW_CARDS_PRECLIENT_ENABLED;
    const size = useWindowSize();
    const typeUser = new URLSearchParams(window.location.search).get('clientType');
    const [valueChip, setValueChip] = useState<any>(0);

    useEffect(() => {
        if (!(isWebviewAndroid && isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const chips: IChipsExplore[] = [
        { text: t('allChipText'), enabled: true, idTrackingFilter: 'filter_all_tapped' },
        { text: t('tvChipText'), enabled: o2TelevisionEnabled, idTrackingFilter: 'filter_tv_tapped' },
        { text: t('devicesExplore'), enabled: devicesEnabled, idTrackingFilter: 'filter_devices_tapped' },
        { text: t('O2cloudTextTitle'), enabled: o2cloudExploreEnabled, idTrackingFilter: 'filter_o2_cloud_tapped' },
        { text: t('rates'), enabled: postSalesEnabled, idTrackingFilter: 'filter_postsales_tapped' },
    ];

    const handleChipChange = (event: any) => {
        setValueChip(event);
        trackingUserInteraction(chips[event].idTrackingFilter as string);
    };

    const cards: ICardExplore[] = [
        {
            type: 1,
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/movistar_plus2x.jpg',
            title: t('cardTelevisionTagText'),
            url: getEnv('VITE_WEBVIEW_O2TELEVISION') as string,
            text: t('cardTelevisionTitleExplore'),
            enabled: o2TelevisionEnabled,
            descriptionText: t('cardTelevisionDescriptionExplore'),
            idTrackingCard: 'tv_button_tapped',
        },
        {
            type: 2,
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/terminales_0923.jpg',
            title: t('titleCardDevices'),
            url: getEnv('VITE_WEBVIEW_DEVICES') as string,
            text: t('titleCardDevices'),
            enabled: devicesEnabled,
            descriptionText: t('exploreBoxedRowMobilesDescription'),
            idTrackingCard: 'devices_button_tapped',
        },
        {
            type: 3,
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/cloud2x.jpg',
            title: t('O2cloudTextTitle'),
            url: getEnv('VITE_WEBVIEW_O2CLOUD') as string,
            text: t('exploreBoxedRowTagO2cloud'),
            enabled: o2cloudExploreEnabled,
            descriptionText: t('O2cloudDescription'),
            idTrackingCard: 'o2_cloud_button_tapped',
        },
        {
            type: 4,
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/tarifas2x.jpg',
            title: t('rates'),
            url: getEnv('VITE_WEBVIEW_POSTSALES') as string,
            text: t('exploreBoxedRowTagRatesTitle'),
            enabled: postSalesEnabled,
            descriptionText: t('exploreBoxedRowRatesDescription'),
            idTrackingCard: 'postsales_button_tapped',
        },
    ];

    const sendToNative = (url: string, type: string, title: string) => {
        if (navigateParams(type, url, {}, {}, title, '', false)) {
            window.location.href = `${url}`;
        }
    };

    const filterCards = (): ICardExplore[] => {
        const filteredCards: ICardExplore[] = cards;
        cards.forEach((card: ICardExplore, index: number) => {
            if (!devicesEnabled && card.title === t('devicesExplore')) {
                filteredCards.splice(index, 1);
            }
            if (!postSalesEnabled && card.title === t('rates')) {
                filteredCards.splice(index, 1);
            }
            if (!o2cloudExploreEnabled && card.title === t('O2cloudTextTitle')) {
                filteredCards.splice(index, 1);
            }
            if (!o2TelevisionEnabled && card.title === t('cardTelevisionTagText')) {
                filteredCards.splice(index, 1);
            }
        });
        return filteredCards;
    };

    return !devicesEnabled && !postSalesEnabled && !o2cloudExploreEnabled && !o2TelevisionEnabled ? (
        <>
            {isBrowser && (
                <div
                    className='explore-page__header'
                    style={{
                        background: skinVars.colors.backgroundBrand,
                    }}
                >
                    <Text6 color={skinVars.colors.textPrimaryInverse}>{t('explore')}</Text6>
                </div>
            )}
            <Stopper></Stopper>
        </>
    ) : (
        <div className='explore-page'>
            {typeUser === ETypeUser.PRECLIENT ? (
                !cardsPreclient ? (
                    <>
                        {isBrowser && (
                            <div
                                className='explore-page__header'
                                style={{
                                    background: skinVars.colors.backgroundBrand,
                                }}
                            >
                                <Text6 color={skinVars.colors.textPrimaryInverse}>{t('explore')}</Text6>
                            </div>
                        )}
                        <div className='explore-page__preclient-emptyState'>
                            <EmptyState
                                asset={<IconShoppingCartRegular color={skinVars.colors.brand} size={64} />}
                                title={t('explore')}
                                description={t('descriptionEmptyExplore')}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div
                            className='explore-page__normalClient-header'
                            style={{ background: skinVars.colors.backgroundBrand }}
                        >
                            <RadioGroup name={'chip'} value={valueChip} onChange={handleChipChange}>
                                <HorizontalScroll>
                                    <div className='explore-page__normalClient-header-chips'>
                                        {chips.map((chip: IChipsExplore, index: any) => {
                                            const { text, enabled } = chip;
                                            if (enabled) {
                                                return (
                                                    <RadioButton
                                                        key={index}
                                                        value={index}
                                                        render={() => (
                                                            <div
                                                                className='explore-page__normalClient-header-chips-chip'
                                                                style={{
                                                                    borderStyle: 'solid',
                                                                    borderWidth: '1px',
                                                                    borderColor: skinVars.colors.inverse,
                                                                    background:
                                                                        valueChip === index
                                                                            ? skinVars.colors.backgroundContainer
                                                                            : skinVars.colors.backgroundBrand,
                                                                }}
                                                            >
                                                                <Text2
                                                                    medium
                                                                    color={
                                                                        valueChip === index
                                                                            ? skinVars.colors.textPrimary
                                                                            : skinVars.colors.inverse
                                                                    }
                                                                >
                                                                    {text}
                                                                </Text2>
                                                            </div>
                                                        )}
                                                    />
                                                );
                                            }
                                        })}
                                    </div>
                                </HorizontalScroll>
                            </RadioGroup>
                        </div>
                        <div className='explore-page__normalClient'>
                            {filterCards().map((card: ICardExplore, key: number) => {
                                const { type, image, text, title, url, enabled, descriptionText, idTrackingCard } =
                                    card;
                                if (enabled) {
                                    if (valueChip === 0) {
                                        return (
                                            <Box
                                                className='explore-page__normalClient-card-text'
                                                key={key}
                                                paddingX={size.width >= 768 ? 32 : 16}
                                                paddingTop={8}
                                                paddingBottom={8}
                                            >
                                                <HighlightedCard
                                                    title={text}
                                                    imageUrl={image}
                                                    description={`${descriptionText}`}
                                                    button={
                                                        <ButtonSecondary
                                                            onPress={() => {
                                                                trackingUserInteraction(`${idTrackingCard}`);
                                                                if (card.title === t('O2cloudTextTitle')) {
                                                                    sendToNative(url, 'modeBrowser', '');
                                                                } else {
                                                                    sendToNative(
                                                                        url,
                                                                        'modeModal-backgroundBlue',
                                                                        title,
                                                                    );
                                                                }
                                                            }}
                                                            small
                                                        >
                                                            {t('contentLoginButton')}
                                                        </ButtonSecondary>
                                                    }
                                                ></HighlightedCard>
                                            </Box>
                                        );
                                    }
                                    if (type === valueChip) {
                                        return (
                                            <Box
                                                className='explore-page__normalClient-card-text'
                                                key={key}
                                                paddingX={size.width >= 768 ? 32 : 16}
                                                paddingTop={8}
                                                paddingBottom={8}
                                            >
                                                <HighlightedCard
                                                    title={text}
                                                    imageUrl={image}
                                                    description={`${descriptionText}`}
                                                    button={
                                                        <ButtonSecondary
                                                            onPress={() => {
                                                                trackingUserInteraction(`${idTrackingCard}`);
                                                                if (card.title === t('O2cloudTextTitle')) {
                                                                    sendToNative(url, 'modeBrowser', '');
                                                                } else {
                                                                    sendToNative(
                                                                        url,
                                                                        'modeModal-backgroundBlue',
                                                                        title,
                                                                    );
                                                                }
                                                            }}
                                                            small
                                                        >
                                                            {t('contentLoginButton')}
                                                        </ButtonSecondary>
                                                    }
                                                ></HighlightedCard>
                                            </Box>
                                        );
                                    }
                                }
                            })}
                        </div>
                    </>
                )
            ) : (
                <>
                    <div
                        className='explore-page__normalClient-header'
                        style={{ background: skinVars.colors.backgroundBrand }}
                    >
                        <RadioGroup name={'chip'} value={valueChip} onChange={handleChipChange}>
                            <HorizontalScroll>
                                <div className='explore-page__normalClient-header-chips'>
                                    {chips.map((chip: IChipsExplore, index: any) => {
                                        const { text, enabled } = chip;
                                        if (enabled) {
                                            return (
                                                <RadioButton
                                                    key={index}
                                                    value={index}
                                                    render={() => (
                                                        <div
                                                            className='explore-page__normalClient-header-chips-chip'
                                                            style={{
                                                                borderStyle: 'solid',
                                                                borderWidth: '1px',
                                                                borderColor: skinVars.colors.inverse,
                                                                background:
                                                                    valueChip === index
                                                                        ? skinVars.colors.backgroundContainer
                                                                        : skinVars.colors.backgroundBrand,
                                                            }}
                                                        >
                                                            <Text2
                                                                medium
                                                                color={
                                                                    valueChip === index
                                                                        ? skinVars.colors.textPrimary
                                                                        : skinVars.colors.inverse
                                                                }
                                                            >
                                                                {text}
                                                            </Text2>
                                                        </div>
                                                    )}
                                                />
                                            );
                                        }
                                    })}
                                </div>
                            </HorizontalScroll>
                        </RadioGroup>
                    </div>
                    <div className='explore-page__normalClient'>
                        {filterCards().map((card: ICardExplore, key: number) => {
                            const { type, image, text, title, url, enabled, descriptionText, idTrackingCard } = card;
                            if (enabled) {
                                if (valueChip === 0) {
                                    return (
                                        <Box
                                            className='explore-page__normalClient-card-text'
                                            key={key}
                                            paddingX={size.width >= 768 ? 32 : 16}
                                            paddingTop={8}
                                            paddingBottom={8}
                                        >
                                            <HighlightedCard
                                                title={text}
                                                imageUrl={image}
                                                description={`${descriptionText}`}
                                                button={
                                                    <ButtonSecondary
                                                        onPress={() => {
                                                            trackingUserInteraction(`${idTrackingCard}`);
                                                            if (card.title === t('O2cloudTextTitle')) {
                                                                sendToNative(url, 'modeBrowser', '');
                                                            } else {
                                                                sendToNative(url, 'modeModal-backgroundBlue', title);
                                                            }
                                                        }}
                                                        small
                                                    >
                                                        {t('contentLoginButton')}
                                                    </ButtonSecondary>
                                                }
                                            ></HighlightedCard>
                                        </Box>
                                    );
                                }
                                if (type === valueChip) {
                                    return (
                                        <Box
                                            className='explore-page__normalClient-card-text'
                                            key={key}
                                            paddingX={size.width >= 768 ? 32 : 16}
                                            paddingTop={8}
                                            paddingBottom={8}
                                        >
                                            <HighlightedCard
                                                title={text}
                                                imageUrl={image}
                                                description={`${descriptionText}`}
                                                button={
                                                    <ButtonSecondary
                                                        onPress={() => {
                                                            trackingUserInteraction(`${idTrackingCard}`);
                                                            if (card.title === t('O2cloudTextTitle')) {
                                                                sendToNative(url, 'modeBrowser', '');
                                                            } else {
                                                                sendToNative(url, 'modeModal-backgroundBlue', title);
                                                            }
                                                        }}
                                                        small
                                                    >
                                                        {t('contentLoginButton')}
                                                    </ButtonSecondary>
                                                }
                                            ></HighlightedCard>
                                        </Box>
                                    );
                                }
                            }
                        })}
                    </div>
                </>
            )}
        </div>
    );
};

export default Explore;
